import { PropsWithChildren } from "react";
import { classNames } from "~/utils/classNames";

export const Panel: React.FC<
  PropsWithChildren<{
    className?: string;
    title?: React.ReactNode;
    titleClassName?: string;
    containerClassName?: string;
    titleControls?: React.ReactNode;
    subtitle?: string;
    titleColor?: "red";
  }>
> = ({
  children,
  title,
  titleClassName,
  className,
  titleControls,
  containerClassName,
  subtitle,
  titleColor,
}) => {
  return (
    <div
      className={classNames(
        "bg-white dark:bg-black dark:border-2 dark:border-gray-700/50 shadow sm:rounded-lg",
        containerClassName
      )}
    >
      {title ? (
        <div
          className={classNames(
            "flex items-center px-4 sm:px-6 pt-5 py-4 justify-between",
            titleClassName
          )}
        >
          <h3
            className={classNames(
              `text-base font-semibold leading-6 flex-`,
              titleColor === "red"
                ? "text-red-500 dark:text-red-500"
                : "text-gray-900 dark:text-gray-200"
            )}
          >
            {title}
          </h3>
          {titleControls ? titleControls : null}
        </div>
      ) : null}
      {subtitle ? (
        <div className="text-sm text-gray-600 px-4 sm:px-6 mb-3">
          {subtitle}
        </div>
      ) : null}
      <hr className="border-gray-200 dark:border-gray-700" />
      <div className={`px-6 py-6 sm:px-12 ${className || ""}`}>{children}</div>
    </div>
  );
};
